export default __webpack_public_path__ + "static/media/ic_sweden.5a3ebbc3.svg";